export const decodeBase64 = (code: string | null) => {
  if (!code) {
    return null;
  }
  try {
    return atob(code);
  } catch (_) {
    return null;
  }
};

export const encodeBase64 = (code: string) => {
  return btoa(code);
};
